// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c1b2f7a6","107":"80f14940","198":"cb9027cd","279":"a9f89e0a","377":"c5bd0d40","404":"be6aa498","412":"3bb12386","426":"fe71f8fe","460":"8bfc1075","498":"6fa1fb13","641":"7290f2cb","724":"0d101d27","933":"5983fa2b","976":"807fbd9d","994":"f520fa32"}[chunkId] + ".chunk.js";
};